<div class="workspace-tab-panel w-100">
  <header class="workspace-section-head mb-4 text-start">
    <h1 class="mb-1">X-Verdict</h1>
    <p class="mb-0">Upload case files, spot key facts, and review eligibility fast.</p>
  </header>

  <div class="workspace-card-grid w-100">
    <article class="workspace-app-card d-flex flex-column align-items-stretch bg-white border shadow-sm text-start">
      <div class="workspace-card-top d-flex align-items-center min-w-0">
        <div class="workspace-platform-icon tone-sky d-inline-flex align-items-center justify-content-center flex-shrink-0">
          <i class="fa fa-balance-scale gradient-text" aria-hidden="true"></i>
        </div>
        <div class="workspace-card-title min-w-0 text-start">
          <h2 class="mb-1">Case Intake & Risk Review</h2>
          <p class="mb-0">Legal Matter Intake</p>
        </div>
      </div>

      <p class="workspace-card-description mb-0 text-start">
        Upload contracts, letters of demand, court documents, or evidence bundles to centralise matters, capture key facts, and track case progress.
      </p>

      <button class="btn upload-button workspace-card-cta d-inline-flex align-items-center justify-content-center w-100" type="button" @click="launch_workspace('case_intake')">
        Upload Legal Document <span aria-hidden="true">&rarr;</span>
      </button>
    </article>

    <article class="workspace-app-card d-flex flex-column align-items-stretch bg-white border shadow-sm text-start">
      <div class="workspace-card-top d-flex align-items-center min-w-0">
        <div class="workspace-platform-icon tone-coral d-inline-flex align-items-center justify-content-center flex-shrink-0">
          <i class="fa fa-hand-holding-heart gradient-text" aria-hidden="true"></i>
        </div>
        <div class="workspace-card-title min-w-0 text-start">
          <h2 class="mb-1">Financial Eligibility & Support</h2>
          <p class="mb-0">Affordability Review</p>
        </div>
      </div>

      <p class="workspace-card-description mb-0 text-start">
        Capture key financial details to review affordability and determine eligibility for legal aid, payment plans, or support options.
      </p>

      <button class="btn upload-button workspace-card-cta d-inline-flex align-items-center justify-content-center w-100" type="button" @click="launch_workspace('credit_help')">
        Review Eligibility <span aria-hidden="true">&rarr;</span>
      </button>
    </article>
  </div>
</div>
